import { useLocation, useNavigate } from 'react-router-dom';
import './logsForm.css';
import { useState } from 'react';
import { Log } from './logs';
import { ReactComponent as SaveProceedingSVG } from '../images/saveProceeding.svg';
import { ReactComponent as LeftSvg } from '../images/left.svg';
import { SquaredIcon } from '../components/squaredIcon';
import { offsetDatetime, post } from './utils/utils';
import axios from 'axios';
import { useAuth } from '../context/context';

export function LogsForm() {

    const { state }: { state: Log} = useLocation();
    const [id] = useState(state.id);
    const [datetime, setDatetime] = useState<Date>(state.datetime);
    const [abstract, setAbstract] = useState(state.abstract);
    const [content, setContent] = useState(state.content);
    const [signature, setSignature] = useState(state.signature);
    let navigate = useNavigate();
    const { user } = useAuth();

    if(!state.id) {
        return (
            <div>
                <p>Ocurrió un error al cargar la información, por favor regresa a la Bitácora e intenta de nuevo.</p>
            </div>
        )
    }

    function addLogItem(event: React.SyntheticEvent<HTMLFormElement>) {
        event.preventDefault();
        if(id) {
            const newLog: Log = {
                content,
                datetime,
                abstract,
                signature,
                id
              };
              const formData = new FormData();
              formData.append('datetime', newLog.datetime.toISOString().slice(0, 19).replace('T', ' '));
              formData.append('content', newLog.content ?? '');
              formData.append('abstract', newLog.abstract ?? '');
              formData.append('signature', newLog.signature ?? '');
              formData.append('id', id);
              post({
                url: 'putLog.php',
                data: formData,
                token: user.token
              })
                .then((response) => response.data)
                .then((data) => {
                  if (data.status === 'ok') {
                    alert("Registro modificado exitosamente!");
                  }
                });
        }
    }

    return (
        <div className='logsForm-container'>
            <form onSubmit={addLogItem}>
                <div className='logForm-header'>
                    <div className='clickable' onClick={() => navigate('/bitacora')}>
                        <LeftSvg style={{width: "20px", height: "20px"}} />
                    </div>
                    <div className='proceedings-submit'>
                        <p>Finalizar registro</p>
                        <button type='submit'>
                            <SquaredIcon icon={<SaveProceedingSVG className='clickable' />} />
                        </button>
                    </div>
                </div>
                <div className='proceedings-section-line'></div>
                <div className="log-new-item">
                    <div className='log-new-item-input'>
                        <label htmlFor='datetime'>Fecha: </label>
                        <input
                            aria-label="Time"
                            type="datetime-local"
                            className="agenda-input"
                            id='datetime'
                            required
                            value={offsetDatetime(datetime).toISOString().split(':00.000Z')[0]}
                            onChange={(event) => setDatetime(new Date(event.target.value))}
                        />
                    </div>
                    <div className='log-new-item-input'>
                        <label htmlFor='abstract'>Resumen: </label>
                        <textarea
                            required
                            id='abstract'
                            className="agenda-input"
                            placeholder="Añadir resumen"
                            rows={3}
                            value={abstract}
                            onChange={(event) => setAbstract(event.target.value)}
                        />
                    </div>
                    <div className='log-new-item-input'>
                        <label htmlFor='content'>Contenido: </label>
                        <textarea
                            required
                            id='content'
                            className="agenda-input"
                            placeholder="Añadir contenido"
                            value={content}
                            rows={4}
                            onChange={(event) => setContent(event.target.value)}
                        />
                    </div>
                    <div className='log-new-item-input'>
                        <label htmlFor='signature'>Firma: </label>
                        <input
                            type="text"
                            className="agenda-input"
                            placeholder="Añadir firma"
                            id='signature'
                            value={signature}
                            onChange={(event) => setSignature(event.target.value)}
                        />
                    </div>
                </div>
            </form>
        </div>
    )
}